import { handleExceldownload, handleResponse, handleError } from "./apiUtils";
import { saveAs } from "file-saver";
const baseUrl = "/api/Data";

//Data import
export function dataImport(files) {
  var formData = new FormData();
  for (var i = 0; i !== files.length; i++) {
    formData.append("files", files[i]);
  }

  return fetch(baseUrl, {
    method: "POST",
    // processData: false,
    // contentType: false,
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
    }),
    body: formData,
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

//Validate Data import Result
export function validateDataImportResult(files, year, month, org, utl) {
  var formData = new FormData();
  for (var i = 0; i !== files.length; i++) {
    formData.append("file", files[i]);
  }
  //needs input-form:
  formData.append("year", year);
  formData.append("month", month);
  formData.append("org", org);
  formData.append("utland", utl);

  return fetch(baseUrl + '/Validation'
    , {
      method: "POST",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      }),
      body: formData,
    })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function getAllCapitalCallsByOrg(org, year) {
  return fetch(baseUrl + "/Summoning/" + org + "?Year=" + year, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getCapitalCallById(id) {
  return fetch(baseUrl + "?Id=" + id, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getYears(org) {
  return fetch(baseUrl + "/Summoning/Years/" + org, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function newCapitalCall(org, capitalCall) {
  return fetch(baseUrl + "/Summoning/" + org, {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "content-type": "application/json",
    }),
    body: JSON.stringify(capitalCall),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.text();
      } else if (response.status === 400) {
        return false;
      } else {
        return await JSON.parse(response.text());
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function updateCapitalCall(capitalCall) {
  return fetch(baseUrl + "/Summoning", {
    method: "PUT",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "content-type": "application/json",
    }),
    body: JSON.stringify(capitalCall),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.text();
      } else if (response.status === 400) {
        return await JSON.parse(response.text());
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function getExcelFileDistributed(id, download) {
  return fetch(
    baseUrl +
    "/Summoning/Distributed?SummoningId=" +
    id +
    "&export=" +
    download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(handleExceldownload)
    .catch(handleError);
}

export function distribute(id) {
  return fetch(baseUrl + "/Distribute?SummoningId=" + id, {
    method: "PUT",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "content-type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.text();
      } else if (response.status === 400) {
        return false;
      } else {
        return await JSON.parse(response.text());
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

//Download execl for capital calls
export function getExcelFile(id, download) {
  return fetch(
    baseUrl +
    "/Summoning/Distributed?SummoningId=" +
    id +
    "&export=" +
    download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.status === 404) {
        return false;
      } else {
        const filename = response.headers
          .get("content-disposition")
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim()
          .replace(/^"(.*)"$/, "$1");
        const blob = await response.blob();
        saveAs(blob, filename);
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function deleteCapitalCall(id) {
  return fetch(`${baseUrl}/Summoning?summoningId=${id}`,
    {
      method: "DELETE",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      })
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.status === 200) {
        return true;
      } else {
        const message = await response.text();
        console.error("Delete failed:", message);
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      return false;
    });
}

export function getIncomes(org, year, month) {
  return fetch("/api/Income/" + org + "?year=" + year + "&month=" + month, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function newIncome(org, income) {
  return fetch("/api/Income/" + org, {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "content-type": "application/json",
    }),
    body: JSON.stringify(income),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else if (response.status === 400) {
        // So, a server-side validation error occurred.
        // Server side validation returns a string error message, so parse as text instead of json.
        const error = await response.text();
        throw new Error(error);
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function updateIncome(org, income) {
  return fetch("/api/Income/" + org, {
    method: "PUT",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "content-type": "application/json",
    }),
    body: JSON.stringify(income),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        const error = await response.text();
        throw new Error(error);
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function deleteIncome(org, year, month) {
  return fetch("/api/Income/" + org + "?year=" + year + "&Month=" + month, {
    method: "DELETE",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

export function getCosts(org, year, month) {
  return fetch(baseUrl + "/" + org + "?Year=" + year + "&Month=" + month, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function newCost(org, year, month, amount) {
  return fetch(
    baseUrl +
    "/" +
    org +
    "?Year=" +
    year +
    "&Month=" +
    month +
    "&Amount=" +
    amount,
    {
      method: "POST",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "content-type": "application/json",
      }),
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else if (response.status === 400) {
        return undefined;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function updateCost(org, year, month, amount) {
  return fetch(
    baseUrl +
    "/" +
    org +
    "?Year=" +
    year +
    "&Month=" +
    month +
    "&Amount=" +
    amount,
    {
      method: "PUT",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "content-type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function deleteCost(org, year, month, amount) {
  return fetch(
    baseUrl +
    "/" +
    org +
    "?Year=" +
    year +
    "&Month=" +
    month +
    "&Amount=" +
    amount,
    {
      method: "DELETE",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

export function getIBNRdata(type, year, month) {
  return fetch(
    baseUrl +
    "/IBNR?incidentType=" +
    type +
    "&year=" +
    year +
    "&month=" +
    month,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function dataImportResultOverview() {
  return fetch(baseUrl + "/DataImportResultOverview", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function dataImportResultTransactions(caseNr) {
  console.log(baseUrl + "/DataImportResultTransactions/" + caseNr);
  return fetch(baseUrl + "/DataImportResultTransactions/" + caseNr, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getYearsIBNR() {
  return fetch(baseUrl + "/IBNR/Years", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function uploadIBNRfile(files) {
  var formData = new FormData();
  for (var i = 0; i !== files.length; i++) {
    formData.append("file", files[i]);
  }

  return fetch(baseUrl + "/IBNR", {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      //"content-type": "multipart/form-data",
    }),
    body: formData,
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}
